import { Component, OnInit } from '@angular/core';
import { CandidateService } from '../../candidate.service';
import { CandidateData } from '../../candidateData';
import { AuthService } from 'src/app/auth/auth.service';
// import * as CanvasJS from '../../../../assets/canvasjs.min';


@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {
  candidateData: CandidateData;
  latestExp;
  latestEducation;
  pos: number;
  checker: Date;
  skills = {
    primarySkills: [],
    additionalSkills: []
  }
  no_experience;

  constructor(private candidateService: CandidateService, private auth: AuthService) { }

  ngOnInit() {
    this.auth.getUserId().subscribe(
      (a) => {
        this.candidateService.getCandidateDetails(a.uid).subscribe(
          (a: CandidateData) => {
            this.candidateData = a;
            console.log(a);
            this.checker = new Date(a.resume.work_experience[0].start_date);
            this.pos = 0;
            for(var i=1; i<a.resume.work_experience.length; i++){
              if(!a.resume.work_experience[i].end_date){
                this.pos = i;
                break;
              }
              else{
                var temp = new Date(a.resume.work_experience[i].start_date);
                if(this.checker < temp){
                  this.checker = temp;
                  this.pos = i;
                }
              }
            }
            this.latestExp = a.resume.work_experience[this.pos];
            console.log("Latest:",this.latestExp)
            //calculate duration in yr,month
            var first_date: Date;
            var second_date: Date;
            var day = 1000 * 60 * 60 * 24;
            var month: number;
            var year: number;
            var diff: any;
            first_date = new Date(this.latestExp.start_date);
            if (this.latestExp.end_date) {
              second_date = new Date(this.latestExp.end_date);
            }else{
              second_date = new Date();
            }
            diff = Math.floor(second_date.getTime() - first_date.getTime());
            month = Math.floor((diff / day) / 31) 
            while(month > 12){
            month = month - 12;
            }
            year = Math.floor(((diff / day) / 31 / 12));
            if(year == 0)
            {
              this.no_experience = "" + month + " mos";  
            }
            else{
              this.no_experience = "" + year + " yrs" + " " + month + " mos";
            }
            //console.log(this.no_experience);

            console.log("Latest:", a.resume.work_experience[this.pos]);
            this.checker = new Date(a.resume.education_details[0].graduationYear);
            this.pos = 0;
            for(var i=1; i<a.resume.education_details.length; i++){
              var gradYear = new Date(a.resume.education_details[i].graduationYear);
              if(this.checker < gradYear){
                this.checker = gradYear;
                this.pos = i;
              }
            }
            this.latestEducation = a.resume.education_details[this.pos];
            this.skills.primarySkills = a.resume.skills.primarySkills;
            this.skills.additionalSkills = a.resume.skills.additionalSkills;
          }
        )
      }
    )
  }
}
